<!-- file t.b.v. downloadknoppen voor het downloaden van de 3d-modelen -->

<template>
  <div v-if="showDownloadUI" class="download-buttons-container">    
    
    <!-- Gebruik v-for om de knoppen te genereren -->
    <div 
      v-for="(button, index) in downloadButtons" 
      :key="index" 
      class="menu-button-icon download-button"
      :title="button.hoverText"
      @click="handleButtonClick(button.action)">
      <mdicon :name="button.icon" />
      <span class="button-label">{{ button.shortLabel }}</span>
    </div>
  </div>
</template>



<script>
import { mapGetters } from 'vuex';

export default {
  name: 'DownloadButtons',
  
  computed: {
    ...mapGetters({
      showDownloadUI: 'getShowDownloadUI'
    }),
    
    downloadButtons() {
      return [
        // {
        //   icon: 'download',
        //   shortLabel: 'SEMA',
        //   hoverText: 'GLB t.b.v. SEMA',
        //   action: 'downloadSEMA'
        // },
        // {
        //   icon: 'download-box',
        //   shortLabel: 'RNDR',
        //   hoverText: 'GLB t.b.v. Renders',
        //   action: 'downloadRender'
        // },
        // {
        //   icon: 'download-circle',
        //   shortLabel: 'DOCS',
        //   hoverText: 'GLB t.b.v. Handleidingen',
        //   action: 'downloadDocs'
        // }
        {
          icon: 'download',
          shortLabel: '3D',
          hoverText: 'GLB downloaden',
          action: 'downloadSEMA'
        }
      ];
    }
  },
  methods: {
    handleButtonClick(action) {
      // console.log('Download button clicked:', action);
      
      // Bepaal het type op basis van de actie
      let type = 'SEMA'; // Default type
      
      if (action === 'downloadSEMA') {
        type = 'SEMA';
      } else if (action === 'downloadRender') {
        type = 'RENDER';
      } else if (action === 'downloadDocs') {
        type = 'DOCS';
      }
      
      // Roep de store actie aan met het juiste type
      this.$store.dispatch('exportModelAsGLB', { type });
    }
  }
}
</script>

<style lang="scss" scoped>

.download-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
}

.download-button {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;
  transition: background-color 0.3s;
  color: white;
  
  &:hover {
    .mdi {
      color: #babc16; /* Alleen het icoon wordt groen bij hover */
    }
    
    .button-label {
      color: #babc16; /* Ook het label wordt groen bij hover */
    }
  }
  
  .button-label {
    font-size: 10px;
    margin-top: 4px;
    color: white;
    transition: color 0.3s;
  }
  
  .mdi {
    transition: color 0.3s;
  }
}
</style>
